/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ModuleCreditCost { 
    moduleKey?: ModuleCreditCost.ModuleKeyEnum;
    label?: string;
    creditCost?: number;
    sortOrder?: number;
    unlimited?: boolean;
}
export namespace ModuleCreditCost {
    export type ModuleKeyEnum = 'HOAI' | 'LOI' | 'QUALITY' | 'MY_CHECK' | 'BIM_BASE' | 'CHAT_BIC' | 'BUILDING_APPLICATIONS';
    export const ModuleKeyEnum = {
        HOAI: 'HOAI' as ModuleKeyEnum,
        LOI: 'LOI' as ModuleKeyEnum,
        QUALITY: 'QUALITY' as ModuleKeyEnum,
        MYCHECK: 'MY_CHECK' as ModuleKeyEnum,
        BIMBASE: 'BIM_BASE' as ModuleKeyEnum,
        CHATBIC: 'CHAT_BIC' as ModuleKeyEnum,
        BUILDINGAPPLICATIONS: 'BUILDING_APPLICATIONS' as ModuleKeyEnum
    };
}